<template>
  <div v-if="current" class="row" id="news-detail-panel">
    <messageModal v-if="showMessage" message="votre news a été mis à jour !" @closeMessage="goToDetail"></messageModal>
        <div class="detailed-news-panel">
            <div class="detailed-news-panel-title">
                <div class="row columns">
                    <div class="medium-9 columns">
                        <p id="tit" contenteditable="true" v-html="current.title"></p>
                    </div>
                    <div class="medium-3 columns">
                        <div class="detailed-news-actions">
                            <button @click="updateContent" class="big">Publier</button>
                        </div>
                    </div>
                </div>
                <hr>
                </div>
                <div id="post_content" class="panel-content">
                    <div class="row columns">
                        <div class="large-5 columns">
                            <imageEditor ref="imgEditor" :imageSrc="current.featured_image"></imageEditor>
                        </div>
                        <div id="par1" v-html="par1" class="large-7 columns" style="text-align:justify" contenteditable="true">
                        </div>
                    </div>
                    <div class="row columns" style="text-align:justify">
                        <div id="par2" v-html="par2" class="large-12 columns" contenteditable="true">
                    </div>
                </div>
            </div>
            </div>
            <button @click="updateContent" class="big">Publier</button>
        </div>
  <div v-else class="row">
    <spinner></spinner>
  </div>
</template>

<script>
import store from '../../store/index.js'
import imageEditor from '../common/image-editor.vue'
import messageModal from '../common/message-modal.vue'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import news from '../../api/news.api'

import spinner from '../common/spinner.vue'

export default {
  name: 'newsEdit',
  props: {
    'id': String
  },
  components: {
    spinner,
    imageEditor,
    messageModal
  },
  data () {
    return {
      par1: '',
      par2: '',
      showMessage: false
    }
  },
  methods: {
    initContent () {
      this.loadContent()
      Vue.nextTick(tick => {
        // quand le chargement claque, on initialise CKeditor
        this.activateEditor()
      })
    },
    loadContent () {
      let dummyElt = document.createElement('div')
      dummyElt.innerHTML = this.current.content
      this.par1 = dummyElt.querySelector('#par1').innerHTML
      this.par2 = dummyElt.querySelector('#par2').innerHTML
    },
    activateEditor () {
      if (!window.CKEDITOR) {
        console.error('Please include CKEditor in your page')
        return
      }
      window.CKEDITOR.disableAutoInline = true
      window.CKEDITOR.inline('tit')
      window.CKEDITOR.inline('par1')
      window.CKEDITOR.inline('par2')
    },
    goToDetail () {
      this.showMessage = false
      this.$router.push({name: 'NewsDetail', params: { id: this.current.id.toString() }})
    },
    checkRights () {
      // afin de vérifier les driots, il faut que :
      // - ou l'utilisateur soit un superuser
      // - ou l'auteur du contenu, soit l'utilisateur connecté
      if (this.currentUser.id !== this.current.user.id &&
        store.getters.currentUser.is_superuser === false) {
        this.$router.push({name: 'NewsDetail', params: { id: this.current.id.toString() }})
        return false
      }
      return true
    },
    updateContent () {
      var updatedPost = this.current
      updatedPost.title = this.$el.querySelector('#tit').innerHTML
      updatedPost.content = this.$el.querySelector('#post_content').innerHTML
      updatedPost.featured_image = this.$refs.imgEditor.currentImageSrc
      updatedPost.featured_club = this.current.featured_club.id
      updatedPost.user = this.current.user.id

      news.api.updateNews(updatedPost)
      .then(response => {
        this.showMessage = true
      },
      error => {
        console.log('impossible to update news')
        console.log(error)
      })
    }
  },
  computed:
  {
    ...mapGetters({
      current: 'detailedNews'
    }),
    ...mapGetters([
      'currentUser'
    ])
  },
  created () {
    // si le contenu n'est pas encore arrivé, on choppe le contenu
    store.dispatch('getDetailedArticle', this.id.toString())
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
  },
  mounted () {
    // si l'utilisateur courant n'est pas chargé
    if (!this.currentUser) {
      store.subscribe((mutation, state) => {
        if (mutation.type === 'setUser') {
          if (this.current) {
            if (this.checkRights()) {
              this.initContent()
            }
          }
        }
      })
    }

    // si le contenu n'est pas chargé
    if (!this.current) {
      // on attend le chargement
      store.subscribe((mutation, state) => {
        if (mutation.type === 'addDetailedArticle') {
          // lorsque le contenu est arrivé on vérifie que l'utilisateur connecté a bien le droit de modifier
          if (this.currentUser) {
            if (this.checkRights()) {
              this.initContent()
            }
          }
        }
      })
    }
    // si toutes les données sont chargées
    if ((this.current) && (this.currentUser)) {
      if (this.checkRights()) {
        this.initContent()
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.detailed-news-panel  {
    background-color: rgba(255,255,255,0.9);
    border-width: 1px;
    border-style: solid;
    border-color: #E1E5EC;
    padding: 0rem;
    margin: 1rem 0rem 1rem 0rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12),0 1px 2px rgba(0,0,0,0.24);
}

.detailed-news-panel-title {
    width: 100%;
    text-align: left;
    font-weight: 300;
    font-size: 2rem;
    padding: 1.4rem 1.4rem 0rem 1.3rem;
}
</style>



// WEBPACK FOOTER //
// news-edit.vue?69915d33